import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const patiantSuggestionService = (formData) => {
    return axiosInstance.post(`api/lab-patient/investigation-suggestion`, formData);
}

export const patiantInvoiceService = (id) => {
    return axiosInstance.get(`healthcare_providers/investigation/invoices/${id}`);
}

export const uploadInvoiceService = (formData) => {
    return axiosInstance.post(`healthcare_providers/investigation/upload-reports`, formData);
}

export const masterTest = () => {
    return axiosInstance.post(`api/test/master`, {});
}

export const masterPackage = () => {
    return axiosInstance.post(`api/package/master`, {});
}

export const masterDoctor = () => {
    return axiosInstance.post(`api/doctors/master`, {});
}

export const testOrder = (formData) => {
    return axiosInstance.post(`api/test-order/create`, formData);
}

